"use strict";

var _slicedToArray = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/regenerator");

var _createClass = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/classCallCheck");

var _assertThisInitialized = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/wrapNativeSuper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MetaMask = exports.NoMetaMaskError = void 0;

var types_1 = require("@web3-react/types");

var NoMetaMaskError = /*#__PURE__*/function (_Error) {
  _inherits(NoMetaMaskError, _Error);

  var _super = _createSuper(NoMetaMaskError);

  function NoMetaMaskError() {
    var _this;

    _classCallCheck(this, NoMetaMaskError);

    _this = _super.call(this, 'MetaMask not installed');
    _this.name = NoMetaMaskError.name;
    Object.setPrototypeOf(_assertThisInitialized(_this), NoMetaMaskError.prototype);
    return _this;
  }

  return NoMetaMaskError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.NoMetaMaskError = NoMetaMaskError;

function parseChainId(chainId) {
  return Number.parseInt(chainId, 16);
}

var MetaMask = /*#__PURE__*/function (_types_1$Connector) {
  _inherits(MetaMask, _types_1$Connector);

  var _super2 = _createSuper(MetaMask);

  function MetaMask(_ref) {
    var _this2;

    var actions = _ref.actions,
        options = _ref.options,
        onError = _ref.onError;

    _classCallCheck(this, MetaMask);

    _this2 = _super2.call(this, actions, onError);
    _this2.options = options;
    return _this2;
  }

  _createClass(MetaMask, [{
    key: "isomorphicInitialize",
    value: function isomorphicInitialize() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.eagerConnection) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                return _context2.abrupt("return", this.eagerConnection = Promise.resolve().then(function () {
                  return __importStar(require('@metamask/detect-provider'));
                }).then(function (m) {
                  return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    var _this4 = this;

                    var _a, _b, provider;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return m.default(this.options);

                          case 2:
                            provider = _context.sent;

                            if (provider) {
                              this.provider = provider; // handle the case when e.g. metamask and coinbase wallet are both installed

                              // handle the case when e.g. metamask and coinbase wallet are both installed
                              if ((_a = this.provider.providers) === null || _a === void 0 ? void 0 : _a.length) {
                                this.provider = (_b = this.provider.providers.find(function (p) {
                                  return p.isMetaMask;
                                })) !== null && _b !== void 0 ? _b : this.provider.providers[0];
                              }

                              this.provider.on('connect', function (_ref2) {
                                var chainId = _ref2.chainId;

                                _this4.actions.update({
                                  chainId: parseChainId(chainId)
                                });
                              });
                              this.provider.on('disconnect', function (error) {
                                var _a;

                                _this4.actions.resetState();

                                (_a = _this4.onError) === null || _a === void 0 ? void 0 : _a.call(_this4, error);
                              });
                              this.provider.on('chainChanged', function (chainId) {
                                _this4.actions.update({
                                  chainId: parseChainId(chainId)
                                });
                              });
                              this.provider.on('accountsChanged', function (accounts) {
                                if (accounts.length === 0) {
                                  // handle this edge case by disconnecting
                                  _this4.actions.resetState();
                                } else {
                                  _this4.actions.update({
                                    accounts: accounts
                                  });
                                }
                              });
                            }

                          case 4:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, this);
                  }));
                }));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /** {@inheritdoc Connector.connectEagerly} */

  }, {
    key: "connectEagerly",
    value: function connectEagerly() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this5 = this;

        var cancelActivation;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                cancelActivation = this.actions.startActivation();
                _context3.next = 3;
                return this.isomorphicInitialize();

              case 3:
                if (this.provider) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", cancelActivation());

              case 5:
                return _context3.abrupt("return", Promise.all([this.provider.request({
                  method: 'eth_chainId'
                }), this.provider.request({
                  method: 'eth_accounts'
                })]).then(function (_ref3) {
                  var _ref4 = _slicedToArray(_ref3, 2),
                      chainId = _ref4[0],
                      accounts = _ref4[1];

                  if (accounts.length) {
                    _this5.actions.update({
                      chainId: parseChainId(chainId),
                      accounts: accounts
                    });
                  } else {
                    throw new Error('No accounts returned');
                  }
                }).catch(function (error) {
                  console.debug('Could not connect eagerly', error); // we should be able to use `cancelActivation` here, but on mobile, metamask emits a 'connect'
                  // event, meaning that chainId is updated, and cancelActivation doesn't work because an intermediary
                  // update has occurred, so we reset state instead

                  // we should be able to use `cancelActivation` here, but on mobile, metamask emits a 'connect'
                  // event, meaning that chainId is updated, and cancelActivation doesn't work because an intermediary
                  // update has occurred, so we reset state instead
                  _this5.actions.resetState();
                }));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * Initiates a connection.
     *
     * @param desiredChainIdOrChainParameters - If defined, indicates the desired chain to connect to. If the user is
     * already connected to this chain, no additional steps will be taken. Otherwise, the user will be prompted to switch
     * to the chain, if one of two conditions is met: either they already have it added in their extension, or the
     * argument is of type AddEthereumChainParameter, in which case the user will be prompted to add the chain with the
     * specified parameters first, before being prompted to switch.
     */

  }, {
    key: "activate",
    value: function activate(desiredChainIdOrChainParameters) {
      var _a, _b;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this6 = this;

        var cancelActivation;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!((_b = (_a = this.provider) === null || _a === void 0 ? void 0 : _a.isConnected) === null || _b === void 0 ? void 0 : _b.call(_a))) cancelActivation = this.actions.startActivation();
                return _context5.abrupt("return", this.isomorphicInitialize().then(function () {
                  return __awaiter(_this6, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                    var _this7 = this;

                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            if (this.provider) {
                              _context4.next = 2;
                              break;
                            }

                            throw new NoMetaMaskError();

                          case 2:
                            return _context4.abrupt("return", Promise.all([this.provider.request({
                              method: 'eth_chainId'
                            }), this.provider.request({
                              method: 'eth_requestAccounts'
                            })]).then(function (_ref5) {
                              var _ref6 = _slicedToArray(_ref5, 2),
                                  chainId = _ref6[0],
                                  accounts = _ref6[1];

                              var receivedChainId = parseChainId(chainId);
                              var desiredChainId = typeof desiredChainIdOrChainParameters === 'number' ? desiredChainIdOrChainParameters : desiredChainIdOrChainParameters === null || desiredChainIdOrChainParameters === void 0 ? void 0 : desiredChainIdOrChainParameters.chainId; // if there's no desired chain, or it's equal to the received, update

                              // if there's no desired chain, or it's equal to the received, update
                              if (!desiredChainId || receivedChainId === desiredChainId) return _this7.actions.update({
                                chainId: receivedChainId,
                                accounts: accounts
                              });
                              var desiredChainIdHex = "0x".concat(desiredChainId.toString(16)); // if we're here, we can try to switch networks
                              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

                              // if we're here, we can try to switch networks
                              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                              return _this7.provider.request({
                                method: 'wallet_switchEthereumChain',
                                params: [{
                                  chainId: desiredChainIdHex
                                }]
                              }).catch(function (error) {
                                if (error.code === 4902 && typeof desiredChainIdOrChainParameters !== 'number') {
                                  // if we're here, we can try to add a new network
                                  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                  return _this7.provider.request({
                                    method: 'wallet_addEthereumChain',
                                    params: [Object.assign(Object.assign({}, desiredChainIdOrChainParameters), {
                                      chainId: desiredChainIdHex
                                    })]
                                  });
                                }

                                throw error;
                              }).then(function () {
                                return _this7.activate(desiredChainId);
                              });
                            }));

                          case 3:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4, this);
                  }));
                }).catch(function (error) {
                  cancelActivation === null || cancelActivation === void 0 ? void 0 : cancelActivation();
                  throw error;
                }));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "watchAsset",
    value: function watchAsset(_ref7) {
      var address = _ref7.address,
          symbol = _ref7.symbol,
          decimals = _ref7.decimals,
          image = _ref7.image;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this.provider) {
                  _context6.next = 2;
                  break;
                }

                throw new Error('No provider');

              case 2:
                return _context6.abrupt("return", this.provider.request({
                  method: 'wallet_watchAsset',
                  params: {
                    type: 'ERC20',
                    options: {
                      address: address,
                      symbol: symbol,
                      decimals: decimals,
                      image: image // A string url of the token logo

                    }
                  }
                }).then(function (success) {
                  if (!success) throw new Error('Rejected');
                  return true;
                }));

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }]);

  return MetaMask;
}(types_1.Connector);

exports.MetaMask = MetaMask;